/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface GrantMentorRequestDTO
 */
export interface GrantMentorRequestDTO {
	/**
	 *
	 * @type {string}
	 * @memberof GrantMentorRequestDTO
	 */
	userId?: string;
	/**
	 *
	 * @type {string}
	 * @memberof GrantMentorRequestDTO
	 */
	cnp?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof GrantMentorRequestDTO
	 */
	mentorDescription?: string | null;
}

export function GrantMentorRequestDTOFromJSON(
	json: any
): GrantMentorRequestDTO {
	return GrantMentorRequestDTOFromJSONTyped(json, false);
}

export function GrantMentorRequestDTOFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): GrantMentorRequestDTO {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		userId: !exists(json, "userId") ? undefined : json["userId"],
		cnp: !exists(json, "cnp") ? undefined : json["cnp"],
		mentorDescription: !exists(json, "mentorDescription")
			? undefined
			: json["mentorDescription"],
	};
}

export function GrantMentorRequestDTOToJSON(
	value?: GrantMentorRequestDTO | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		userId: value.userId,
		cnp: value.cnp,
		mentorDescription: value.mentorDescription,
	};
}
